import React, { useEffect, useState } from 'react'
import Table from "../../components/table";

function ActivePositions(props:any) {
 

const [data, setData] = useState<any>([])
const [total, setTotal] = useState<number>()
  useEffect(() => { 
  if(props.positions){
    setData(props && props.positions &&  props.positions)
    setTotal(props.total)    
  }
   
  }, [props, props.positions, props.total])
  

const pageChange = (data: any) => {

}
const rowClick = (data:any) => {
  
  
  }

  const pageSize = (pageSize: any, pageNumber: number) => {
  
    props.pageSize(pageSize, pageNumber);
    
  };

  return (
    <section className="tableStyle">
      <Table draftKey={props.draftKey} s getTablesValues={props.getTableValues} pageSize={pageSize } data={data} rowClick={rowClick} total={total} pageChange={pageChange} type={'positions'}/>
    </section>
  );
}


export default ActivePositions